import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubSink } from 'subsink';

@Component({
  selector: 'kion-cms-search-no-result',
  templateUrl: './search-no-result.component.html',
  styleUrls: ['./search-no-result.component.scss']
})
export class SearchNoResultComponent implements OnInit, OnDestroy {

  query: string;

  private subSink: SubSink;

  constructor(
    private route: ActivatedRoute
  ) {
    this.subSink = new SubSink();
  }

  ngOnInit(): void {
    this.subSink.sink = this.route.queryParams.subscribe(
      params => {
        if (params.query) {
          this.query = params.query
        }
      }
    )
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
